//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'
import Cookie from '../utils/Cookie'
import Window from '../utils/Window'

let timer = null

export default {
  name: 'm-order',
  data () {
    return {
      countdownTimer: 1800,
      orderCode: '',
      productName: '',
      company: '',
      holderName: '',
      holderIdNumber: '',
      insuredName: '',
      insuredIdNumber: '',
      coverage: '',
      coverageStr: '',
      paymentPeriod: '',
      insurancePeriod: '',
      paymentWay: '年交',
      paymentMode: '',
      mild: false,
      tickets: [],
      amountBySelectedTickets: 0,
      showTicket: false,
      premium: '',
      Window: Window,
      isUseCoupon: false,
      agreeTerms: true,
      fitflag: true
    }
  },
  created () {
    const data = {}
    if (this.$route.query.activityCode) {
      data.activityCode = this.$route.query.activityCode
    }
    let orderQuerenURL = '/api/hqdqx/orderQueren/'
    if (this.h5) {
      orderQuerenURL = '/api/channel/hqdqx/orderQueren/'
    }
    console.log(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode + '?' + qs.stringify(data))
    this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode + '?' + qs.stringify(data)).then(response => {
      console.log(response)
      this.orderCode = response.data.busOrder.orderCode // 订单号
      this.productName = response.data.busProductRelation.productName // 产品名称
      this.company = response.data.busProductRelation.suppliername // 承保公司
      this.holderName = response.data.underwritingInfoList[0].policyHolder.holderName
      this.holderIdNumber = response.data.underwritingInfoList[0].policyHolder.holderIdNumber
      this.insuredName = response.data.underwritingInfoList[0].policyInsured.insuredName
      this.insuredIdNumber = response.data.underwritingInfoList[0].policyInsured.insuredIdNumber
      this.paymentMode = response.data.underwritingInfoList[0].policyInsured.payMode === 1 ? '年交' : '月交'
      this.coverage = response.data.underwritingInfoList[0].coverage / 1000000
      if (response.data.underwritingInfoList[0].coverage < 10000000) {
        this.coverageStr = '每' + (response.data.underwritingInfoList[0].policyInsured.payMode === 1 ? '年' : '月') + '可领取' + response.data.underwritingInfoList[0].coverage / 100 + '元至终身'
      } else {
        this.coverageStr = '每' + (response.data.underwritingInfoList[0].policyInsured.payMode === 1 ? '年' : '月') + '可领取' + response.data.underwritingInfoList[0].coverage / 1000000 + '万元至终身'
      }
      if (response.data.underwritingInfoList[0].policyInsured.payMode !== 1 && response.data.underwritingInfoList[0].policyInsured.payMode !== 2) {
        this.coverageStr = response.data.underwritingInfoList[0].coverage / 1000000 + '万'
      }
      this.paymentPeriod = response.data.underwritingInfoList[0].policyInsured.insurePayWay
      this.holderPhone = response.data.underwritingInfoList[0].policyHolder.holderPhone
      this.premium = response.data.underwritingInfoList[0].actualPrice / 100
      this.isUseCoupon = response.data.isUseCoupon === 1
      this.$store.state.config.form.insurancePeriods.list.forEach(ele => {
        if (Number(response.data.underwritingInfoList[0].policyInsured.durationPeriodValue) === ele.value.value) {
          switch (ele.value.typeCode) {
            case 2:
              this.insurancePeriod = '至' + ele.value.value + '周岁'
              break
            case 1:
              this.insurancePeriod = ele.value.value + '年'
              break
            case 0:
              this.insurancePeriod = '终身'
              break
          }
        }
      })
      if (response.data.underwritingInfoList[0].additionalRiskCodes) this.mild = true

      // 百年产品线上流程倒计时为当天24:00,改变线下核保倒计时的开始时间
      if (this.isAeonlife()) {
        if (window.sessionStorage.getItem('isoffline') !== 'offline') {
          const today = new Date()
          const todayY = today.getFullYear()
          const todayM = today.getMonth()
          const todayD = today.getDate()
          let thisDayTime = new Date(todayY, todayM, todayD + 1)
          this.countdownTimer = Math.floor((thisDayTime.getTime() - Date.now()) / 1000)
          timer = setInterval(() => {
            if (this.countdownTimer <= 0) {
              clearInterval(timer)
            }
            this.countdownTimer--
          }, 1000)
        }
      } else {
        const passSeconds = Math.floor((Date.now() - response.data.orderCreateDate) / 1000)
        this.countdownTimer = this.countdownTimer - passSeconds
        this.countdownTimer = this.countdownTimer < 0 ? 0 : this.countdownTimer
        timer = setInterval(() => {
          if (this.countdownTimer <= 0) {
            clearInterval(timer)
          }
          this.countdownTimer--
        }, 1000)
      }
      // 获取券的信息
      if (this.tickets.length === 0) {
        this.$http.post('/api/coupon/getUserValidCouponCount', qs.stringify({'productCode': this.$store.state.app.productCode, orderCode: response.data.underwritingInfoList[0].orderCode, 'openid': Cookie.getCookie('session_wechat_user_openid')})).then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            response.data.data.forEach(ele => {
              ele.selected = false
              this.tickets.push(ele)
            })
          }
        })
      }
    })
  },
  mounted () {
    document.title = '订单确认'
    // 订单确认页不显示倒计时
    if (this.isAeonlifeUnderwriting) {
      this.fitflag = false
    }
    this.$http.get('https://m.wkbins.com/explosions/static/common/js/tongji.txt?where=order&productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')).then(response => {
    })
  },
  destroyed () {
  },
  computed: {
    isAeonlifeUnderwriting () {
      return window.sessionStorage.getItem('fit') === 'false' && this.isAeonlife() && window.sessionStorage.getItem('isoffline') === 'offline'
    },
    h5 () {
      return this.$store.state.app.h5
    },
    orderForm () {
      if (this.$store.state.config.order) {
        return this.$store.state.config.order.form
      }
    },
    mildCoverage () {
      return this.coverage * (this.$store.state.config.form.mildCoverage.realRate || this.$store.state.config.form.mildCoverage.rate) + '万'
    },
    agreement () {
      if (this.$store.state.config.order) {
        return this.$store.state.config.order.agreement
      }
    },
    tickedBtnText () {
      if (this.selectedTickets.length > 0) {
        return '您已使用' + this.selectedTickets.length + '张券,已优惠' + this.amountBySelectedTickets + '元'
      }
      return '有' + this.tickets.length + '张可用'
    },
    selectedTickets () {
      const selected = []
      this.tickets.forEach((ele) => {
        if (ele.selected) {
          selected.push(ele)
        }
      })
      return selected
    }
  },
  methods: {
    payNow () {
      // 订单逾期
      if (this.countdownTimer <= 0 && !this.isAeonlifeUnderwriting) {
        const that = this
        this.$vux.confirm.show({
          confirmText: '重新下单',
          title: '订单逾期',
          content: '订单逾期，请重新下单！',
          onConfirm () {
            that.$router.push({name: that.$store.state.config.policy.path || 'Form', params: {productCode: that.$store.state.app.productCode, innerCode: that.$store.state.app.innerCode}, query: that.$route.query})
          }
        })
        return
      }
      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意相关内容后再试',
          position: 'top',
          width: '20em'
        })
        return
      }
      this.$vux.loading.show({
        text: '正在提交'
      })
      // 活动
      let judgeURL = (this.h5 ? '/api/channel/illness/judgeInsurance/' : '/api/illness/judgeInsurance/') + this.$store.state.order.unionCode
      judgeURL += '?innerCode=' + this.$store.state.app.innerCode
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1) {
        if (this.selectedTickets.length > 0) {
          let coupons = ''
          this.selectedTickets.forEach((ele) => {
            coupons += ele.couponCode + ','
          })
          coupons = coupons.substring(0, coupons.length - 1)
          judgeURL += '&coupons=' + coupons
        }
        judgeURL += '&openid=' + Cookie.getCookie('session_wechat_user_openid')
      }
      this.$http.get(judgeURL).then(response => {
        this.$vux.loading.hide()
        if (response.data[0].undwrtStatus === 0) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，正在核保中，请稍后再试',
            position: 'top',
            width: '20em'
          })
          return
        }
        if (response.data[0].undwrtStatus === 2) {
          this.$vux.alert.show({
            title: '核保失败',
            content: response.data[0].undwrtMsg || '核保超时',
            buttonText: '知道了'
          })
          return
        }
        console.log(this.$store.state.order.unionCode)
        console.log(this.$route.query)
        this.$router.push({name: 'Pay', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
      })
    },
    ticketType (value) {
      if (value === 1) {
        return '现金券'
      } else if (value === 2) {
        return '折扣券'
      } else if (value === 5) {
        return '现金券'
      } else if (value === 6) { // 通用折扣券
        return '折扣券'
      }
      // if (value === 'all_products') {
      //   return '通用券'
      // } else if (value === 1 || value === 5) {
      //   return '现金券'
      // }
      // return '定向券'
    },
    ticketValue (type, value) {
      if (type === 1 || type === 5) {
        return value / 100 + '元'
      } else if (type === 2 || type === 6) {
        return value / 10 + '折'
      }
    },
    showTickets () {
      if (this.tickets.length > 0) {
        this.showTicket = true
        return
      }
      this.$vux.toast.show({
        type: 'text',
        text: '客官，您没有可用的优惠券',
        position: 'top',
        width: '20em'
      })
    },
    selectTicket (index) {
      if (this.tickets[index].selected) {
        this.tickets[index].selected = false
      } else {
        const type = this.tickets[index].type
        this.tickets.forEach((ele) => {
          if (ele.type === type) {
            ele.selected = false
          }
        })
        this.tickets[index].selected = true
      }
      // 计算优惠金额
      if (this.selectedTickets.length === 0) {
        this.amountBySelectedTickets = 0
        return
      }
      const data = {coupons: '', orderSum: this.premium * 100, openid: Cookie.getCookie('session_wechat_user_openid')}
      this.selectedTickets.forEach((ele) => {
        data.coupons += ele.couponCode + ','
      })
      data.coupons = data.coupons.substring(0, data.coupons.length - 1)
      this.$http.post('/api/coupon/calcUserChoseCoupon', qs.stringify(data)).then((response) => {
        this.amountBySelectedTickets = Number(response.data) / 100
      })
    },
    sureTicket () {
      this.showTicket = false
    },
    isAeonlife () {
      if (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1) {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Order.vue